import country from '@/utilities/country'
import map from '@/utilities/map'
import money from '@/utilities/money'

export default {
  country,
  map,
  money
}
